import React from 'react';
import Tabs from 'components/tabs';
import Tool from 'pages/index/Tool';
import { useTypedSelector } from 'store/index';
import { Application } from 'store/application';
import celue from 'images/industry-yingxiao-celue.jpg';
import jijian from 'images/industry-yingxiao-jijian.jpg';
import neirong from 'images/industry-yingxiao-neirong.jpg';
import yonghu from 'images/industry-yingxiao-yonghu.jpg';
import huochang from 'images/industry-yingxiao-huochang.jpg';

const operateServices = [
  {
    img: jijian,
    label: '私域基建',
    bg: '#f1ece8',
  },
  {
    img: celue,
    label: '私域策略',
    bg: '#ecf1f4',
  },
  {
    img: neirong,
    label: '内容运营',
    bg: '#ede9e8',
  },
  {
    img: yonghu,
    label: '用户运营',
    bg: '#dfe5f0',
  },
  {
    img: huochang,
    label: '货场管理',
    bg: '#e2dfe9',
  },
];

const contentServices = [
  {
    img: 'https://union.gdtimg.com/webstore/service-jia-zhi-bang-dan.png',
    label: '价值榜单',
    bg: '#f1ece8',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-kol.png',
    label: 'KOL 筛选',
    bg: '#ecf1f4',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-cai-hao-fu-wu.png',
    label: '采号服务',
    bg: '#ede9e8',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-nei-rong-zhi-zuo.png',
    label: '内容制作',
    bg: '#dfe5f0',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-shu-ju-jian-kong.png',
    label: '数据监控',
    bg: '#e2dfe9',
  },
];

const dataServices = [
  {
    img: 'https://union.gdtimg.com/webstore/service-ding-xiang-ce-lve.png',
    label: '定向策略',
    bg: '#e8eef1',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-ren-qun-dong-cha.png',
    label: '人群洞察',
    bg: '#e2e9ff',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-gui-yin-fen-xi.png',
    label: '归因分析',
    bg: '#fff5f0',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-shu-ju-guan-li.png',
    label: '数据管理',
    bg: '#eaeafa',
  },
  {
    img: 'https://union.gdtimg.com/webstore/service-shu-ju-jian-mo.png',
    label: '数据建模',
    bg: '#dff7fc',
  },
];

const Services = () => {
  const contentTools: Application[] = [];
  const dataTools: Application[] = [];
  const daiYunYing: Application[] = [];

  const list = useTypedSelector((state) => state.application.list);
  Object.keys(list).forEach((id) => {
    if (list[id].category === 11 && list[id].status === 1) {
      contentTools.push(list[id]);
    }
    if (list[id].category === 12 && list[id].status === 1) {
      dataTools.push(list[id]);
    }
    if (list[id].category === 13 && list[id].status === 1) {
      daiYunYing.push(list[id]);
    }
  });

  return (
    <section className="services">
      <div className="fade text-bold header">广告营销服务</div>
      <div className="fade text-bold sub-header">MARKETING SERVICES</div>

      <Tabs className="fade" tabs={['代运营服务', '内容服务', '数据服务']}>
        <>
          <div className="text-center">
            提供私域现状诊断、私域运营策略及执行服务，包括小程序商城运营、公众号内容运营、私域用户运营、
          </div>
          <div className="text-center">
            视频号代运营、私域带教等，帮助客户在长效ROI、私域粉丝数量、单客价值等方面有效提升。
          </div>
          <div className="service-list">
            {operateServices.map(({ label, img, bg }) => (
              <figure key={label}>
                <div
                  style={{
                    height: '182px',
                    background: `url(${img}) no-repeat`,
                    backgroundSize: 'auto 182px',
                    backgroundPosition: 'center',
                  }}
                ></div>
                <figcaption className="text-bold" style={{ backgroundColor: bg }}>
                  {label}
                </figcaption>
              </figure>
            ))}
          </div>
          <div className="tools-list">
            {daiYunYing.map((tool) => (
              <Tool
                key={tool.client_id}
                icon={tool.app_icon}
                name={tool.app_name}
                url={`/application/${tool.client_id}`}
                track="app-detail"
                data-client-id={tool.client_id}
              />
            ))}
          </div>
        </>
        <>
          <div className="text-center">提供价值榜单透视 KOL 能力，使用效果预测模型及用户圈层数据助力高效筛选</div>
          <div className="text-center">KOL；实时监控社交带货及商业化数据；并可提供专业内容制作服务用于社交推广。</div>
          <div className="service-list">
            {contentServices.map(({ label, img, bg }) => (
              <figure key={label}>
                <img src={img} alt="" />
                <figcaption className="text-bold" style={{ backgroundColor: bg }}>
                  {label}
                </figcaption>
              </figure>
            ))}
          </div>
          <div className="tools-list">
            {contentTools.map((tool) => (
              <Tool
                key={tool.client_id}
                icon={tool.app_icon}
                name={tool.app_name}
                url={`/application/${tool.client_id}`}
                track="app-detail"
                data-client-id={tool.client_id}
              />
            ))}
          </div>
        </>
        <>
          <div className="text-center">与生态伙伴共建，提供从广告投放、用户分析、获客管理等</div>
          <div className="text-center">多行业数据解决方案，为业务增长注入新动力。</div>
          <div className="service-list">
            {dataServices.map(({ label, img, bg }) => (
              <figure key={label}>
                <img src={img} alt="" />
                <figcaption className="text-bold" style={{ backgroundColor: bg }}>
                  {label}
                </figcaption>
              </figure>
            ))}
          </div>
          <div className="tools-list">
            {dataTools.map((tool) => (
              <Tool
                key={tool.client_id}
                icon={tool.app_icon}
                name={tool.app_name}
                url={`/application/${tool.client_id}`}
                track="app-detail"
                data-client-id={tool.client_id}
              />
            ))}
          </div>
        </>
      </Tabs>
    </section>
  );
};

export default Services;
